import { ProductRatingService } from './../../../../../providers/services/product-rating.service';
import { takeUntil } from 'rxjs/operators';
import { ProductRatingRequest } from './../../../../../models/product-rating-request';
import { Component, OnInit, Input } from '@angular/core';
import { ProductBasicResponse, Company } from '@pdp/common';
import { Category } from '../../../../../models/category';
import { ProductService } from '../../../../../providers/services/product.service';
import { ProductQuantity } from '../../../../../models/product-quantity';
import { Subject } from 'rxjs';
import { NgClass, NgIf, CurrencyPipe } from '@angular/common';
import { RouterLink } from '@angular/router';
import { BarRatingModule } from 'ngx-bar-rating';

@Component({
    selector: 'pdp-product-list-item',
    templateUrl: './product-list-item.component.html',
    styleUrls: ['./product-list-item.component.scss'],
    imports: [NgClass, RouterLink, NgIf, BarRatingModule, CurrencyPipe]
})
export class ProductListItemComponent implements OnInit {

  private unsubscribe: Subject<void> = new Subject();

  @Input()
  public product: ProductBasicResponse;

  @Input()
  public isFeatured: boolean;
  public routerLinkUrl: string;
  @Input()
  public category: Category;
  @Input()
  public company: Company;

  public productQuantity: ProductQuantity;
  public primaryImage: string;

  constructor(public productService: ProductService,
    public ratingService: ProductRatingService) { }


  public updateRating(rating: number) {
    const request: ProductRatingRequest = new ProductRatingRequest();
    request.productId = this.product.id;
    request.rating = rating;
    this.ratingService.rateProduct(request).pipe(takeUntil(this.unsubscribe)).subscribe(() => {

    });
  }
  ngOnInit() {
    if (this.product) {
      if (this.product['image_url']) {
        this.primaryImage = this.product['image_url'];
      } else {
        this.primaryImage = 'assets/images/img-not-available.png';
      }
      this.productQuantity = this.productService.computeQuantity(this.product['quantityAvailable'], this.product['salesAvailabilityType']);
    }
    this.routerLinkUrl = this.isFeatured ? '/search/itm' + this.product['product_url'] : './itm' + this.product['product_url'];
  }

  ngOnDestroy() {
    this.unsubscribe.next(undefined);
    this.unsubscribe.complete();
  }
}
